import React, { useEffect, useState } from "react";
import loaderGif from "../../../../public/Images/synopsis/alpha-spinner.gif"
import Image from "next/image";
import { createPortal } from "react-dom";

const Loader = ({ loadingString = null }) => {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const el = document.createElement('div');
    el.setAttribute('data-loader-portal', 'true');
    document.body.appendChild(el);
    setContainer(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, []);

  const loaderContent = (
    <div style={{ zIndex: 999999 }} className="loader fixed inset-0 flex items-center justify-center bg-black/50">
      <div className="flex flex-col items-center">
        <Image src={loaderGif} alt="loader" width={100} height={100} />
        <p className="loading mt-4">{loadingString ? loadingString : 'Loading...'}</p>
      </div>
    </div>
  );

  if (typeof window === 'undefined' || !container) {
    return null;
  }
  return createPortal(loaderContent, container);
};

export default Loader;
